/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style10 = require('antd/lib/modal/style');

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _style11 = require('antd/lib/table/style');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _style12 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _style13 = require('antd/lib/slider/style');

var _slider = require('antd/lib/slider');

var _slider2 = _interopRequireDefault(_slider);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _style14 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style15 = require('antd/lib/date-picker/style');

var _datePicker = require('antd/lib/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _style16 = require('antd/lib/input/style');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _style17 = require('antd/lib/form/style');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _style18 = require('antd/lib/select/style');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _tool = require('../../utils/tool');

var _config = require('../../utils/config');

var _reactRouter = require('react-router');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _select2.default.Option;

var FormItem = _form2.default.Item;
var Search = _input2.default.Search;
var MonthPicker = _datePicker2.default.MonthPicker,
    RangePicker = _datePicker2.default.RangePicker;

var _ref = (0, _jsx3.default)('strong', {}, void 0, 'SOH');

var _ref2 = (0, _jsx3.default)('span', {
  className: 'battery-name'
}, void 0, '\u7535\u6C60');

var _ref3 = (0, _jsx3.default)(Option, {
  value: '0'
}, void 0, '\u672A\u77E5');

var _ref4 = (0, _jsx3.default)(Option, {
  value: '1'
}, void 0, '\u6709\u7EBF');

var _ref5 = (0, _jsx3.default)(Option, {
  value: '2'
}, void 0, '\u65E0\u7EBF');

var _ref6 = (0, _jsx3.default)('p', {}, void 0, '\u662F\u5426\u786E\u5B9A\u8981\u6CE8\u9500\u6B64\u8BBE\u5907\uFF1F');

var BatMan = function (_Component) {
  (0, _inherits3.default)(BatMan, _Component);

  function BatMan(props, state) {
    (0, _classCallCheck3.default)(this, BatMan);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BatMan.__proto__ || (0, _getPrototypeOf2.default)(BatMan)).call(this, props, state));

    _this.disabledStartDate = function (startValue) {
      var endValue = _this.state.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    };

    _this.disabledEndDate = function (endValue) {
      var startValue = _this.state.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return endValue.valueOf() <= startValue.valueOf();
    };

    _this.onChange = function (field, value) {
      _this.setState((0, _defineProperty3.default)({}, field, value));
    };

    _this.onStartChange = function (value) {
      if (value !== null) {
        var startTime = _this.getUnix(value._d);
      }
      _this.onChange('startValue', startTime ? startTime : value);
    };

    _this.onEndChange = function (value) {
      if (value !== null) {
        var endTime = _this.getUnix(value._d);
      }
      _this.onChange('endValue', endTime ? endTime : value);
    };

    _this.handleStartOpenChange = function (open) {
      if (!open) {
        _this.setState({ endOpen: true });
      }
    };

    _this.handleEndOpenChange = function (open) {
      _this.setState({ endOpen: open });
    };

    _this.state = {
      deletebatteryNumber: '',
      p: {
        PageSize: 10,
        current: 1,
        // showSizeChanger:true,
        showQuickJumper: true,
        total: 0,
        showTotal: function showTotal(total) {
          return '\u5171 ' + total + ' \u6761';
        }
      },
      startValue: null, //开始时间
      endValue: null, //结束时间
      endOpen: false,
      sohGreaterThanValue: '', // soh大于
      sohLessThanValue: '', // soh小于
      sohArr: [0, 100],
      frequencyGreaterThanValue: '', //充电次数 大于
      frequencyLessThanValue: '', //充电次数 小于
      searchNumberValue: '', // 搜索框
      type: '', // 有线and无线
      onlineStatus: '', // 当前状态
      visible: false,
      data: [],
      chargingStatus: [{
        key: '1',
        name: '换电中'
      }, {
        key: '2',
        name: '使用中'
      }]
    };
    return _this;
  }

  /*2019.8.21*/


  (0, _createClass3.default)(BatMan, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.handleGetList();
    }
  }, {
    key: 'handleGetList',
    value: function handleGetList() {
      var _this2 = this;

      var data = this.state;
      (0, _tool.http)(_config.apiJson.getPagedBaseBatteryInfoList, {
        page: data.p.current,
        rows: data.p.PageSize,
        modifyTimeBegin: data.startValue,
        modifyTimeEnd: data.endValue,
        status: data.onlineStatus,
        type: data.type,
        sohBegin: data.sohArr[0],
        sohEnd: data.sohArr[1],
        numberOrSpecs: data.searchNumberValue

      }).then(function (res) {
        var rows = res.rows || [];
        _this2.setState({
          data: rows,
          p: {
            total: res.total
          }
        });
      }).catch(function (res) {
        var msg = !res.errmsg ? '' + res : res.errmsg;
      });
    }
  }, {
    key: 'handlePage',
    value: function handlePage(current) {
      var _this3 = this;

      //TODO 解构
      (0, _tool.http)(_config.apiJson.getPagedBaseBatteryInfoList, {
        page: current.current,
        rows: current.pageSize,
        modifyTimeBegin: this.state.startValue,
        modifyTimeEnd: this.state.endValue,
        status: this.state.onlineStatus,
        type: this.state.type,
        sohBegin: this.state.sohGreaterThanValue,
        sohEnd: this.state.sohLessThanValue,
        numberOrSpecs: this.state.searchNumberValue

      }).then(function (res) {
        var rows = res.rows || [];
        _this3.setState({
          data: rows,
          p: {
            total: res.total
          }
        });
      }).catch(function (res) {
        var msg = !res.errmsg ? '' + res : res.errmsg;
        Message.error(msg);
      });
    }
  }, {
    key: 'handleDel',
    value: function handleDel() {
      var _this4 = this;

      var that = this;
      (0, _tool.http)(_config.apiJson.delOneBaseBatteryInfo, {
        batteryNumber: this.state.deletebatteryNumber
      }).then(function (res) {
        _this4.setState({
          visible: false
        });
        _message2.default.success('删除成功');
        _this4.handleGetList();
      }).catch(function (res) {
        var msg = !res.errmsg ? '' + res : res.errmsg;
      }).finally(function () {
        that.setState({
          deletebatteryNumber: ''
        });
      });
    }
    /*------------------------------------------*/

  }, {
    key: 'getUnix',
    value: function getUnix(dateStr) {
      var timeUnix = Date.parse(new Date('' + dateStr));

      return timeUnix;
    }
  }, {
    key: 'showDeleteModal',
    value: function showDeleteModal(record) {
      this.setState({
        deletebatteryNumber: record.batteryNumber
      });
      this.setState({
        visible: true
      });
    }
  }, {
    key: 'cancelDeleteModal',
    value: function cancelDeleteModal() {
      this.setState({
        visible: false
      });
    }
  }, {
    key: 'handleChangeOne',
    value: function handleChangeOne(value) {
      this.setState({
        type: value
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(value) {
      this.setState({
        onlineStatus: value
      });
    }
  }, {
    key: 'searchNumber',
    value: function searchNumber(e) {
      this.setState({
        searchNumberValue: e.target.value
      });
    }
  }, {
    key: 'onSohChange',
    value: function onSohChange(value) {
      console.log('onChange: ', value);
      this.setState({
        sohArr: value
      });
    }
  }, {
    key: 'sohGreaterThan',
    value: function sohGreaterThan(value) {
      this.setState({
        sohGreaterThanValue: value
      });
    }
  }, {
    key: 'sohLessThan',
    value: function sohLessThan(value) {
      this.setState({
        sohLessThanValue: value
      });
    }
  }, {
    key: 'frequencyGreaterThan',
    value: function frequencyGreaterThan(value) {
      this.setState({
        frequencyGreaterThanValue: value
      });
    }
  }, {
    key: 'frequencyLessThan',
    value: function frequencyLessThan(value) {
      this.setState({
        frequencyLessThanValue: value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      //  params.id 是 productId
      var _props = this.props,
          product = _props.product,
          params = _props.params;
      var getFieldDecorator = this.props.form.getFieldDecorator;
      var chargingStatus = this.state.chargingStatus;
      var _state = this.state,
          startValue = _state.startValue,
          endValue = _state.endValue,
          endOpen = _state.endOpen;

      var marks = {
        0: '0',
        100: {
          style: {
            color: '#f50'
          },
          label: _ref
        }
      };
      var columns = [{
        title: "硬件SN号",
        dataIndex: "batteryNumber",
        key: 'batteryNumber',
        render: function render(text, record) {
          return (0, _jsx3.default)('p', {}, void 0, record.batteryNumber || '-');
        }
      }, {
        title: "电池规格",
        dataIndex: "specs",
        key: 'specs',
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {}, void 0, record.specs || '-');
        }
      }, {
        title: "有线/无线充电",
        dataIndex: "type",
        key: 'type',
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {}, void 0, record.type === 1 ? '有线' : record.type === 2 ? '无线' : '未知');
        }
      }, {
        title: "当前状态",
        dataIndex: "status",
        key: 'status',
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {}, void 0, record.status === 1 ? '换电中' : '使用中');
        }
      }, {
        title: "充电次数",
        dataIndex: "totalChargedTimes",
        key: 'totalChargedTimes',
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {}, void 0, record.totalChargedTimes || '0');
        }
      }, {
        title: "SOH",
        dataIndex: "soh",
        key: 'soh',
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {}, void 0, record.soh || '1');
        }
      }, {
        title: "报警",
        dataIndex: "1",
        key: '1',
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {}, void 0, record.deviceId || '-');
        }
      }, {
        title: "最近使用时间",
        dataIndex: "lastModifyTime",
        key: 'lastModifyTime',
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {}, void 0, record.lastModifyTime || '-');
        }
      }, {
        title: "首次使用时间",
        dataIndex: "createTime",
        key: 'createTime',
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {}, void 0, record.createTime || '-');
        }
      }, {
        title: "操作",
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {
            className: 'device-table-btn-group'
          }, void 0, (0, _jsx3.default)('a', {
            href: 'javascript:void(0);',
            style: { fontSize: "14px" },
            onClick: function onClick() {
              _this5.showDeleteModal(record);
            },
            className: 'delete'
          }, void 0, '\u5220\u9664'), (0, _jsx3.default)(_reactRouter.Link, {
            to: '/batterymanagement/batdetail/' + params.id + '/' + record.batteryNumber,
            style: { fontSize: "14px" }
          }, void 0, '\u67E5\u770B\u8BE6\u60C5'));
        }
      }];

      return (0, _jsx3.default)('div', {
        className: 'battery-list'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'battery-header'
      }, void 0, _ref2, (0, _jsx3.default)('span', {
        className: 'battery-num'
      }, void 0, '\u603B\u6570\uFF1A', (0, _jsx3.default)('strong', {}, void 0, this.state.p.total))), (0, _jsx3.default)('div', {
        className: 'battery-from'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'battery-alltime'
      }, void 0, getFieldDecorator("onstartchange", {
        rules: [{ required: false, message: "" }]
        // initialValue: this.state.startValue
      })((0, _jsx3.default)(_datePicker2.default, {
        className: 'battery-start',
        disabledDate: this.disabledStartDate,
        showTime: true,
        allowClear: true,
        style: { width: 190 },
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '\u5F00\u59CB\u65F6\u95F4',
        onChange: this.onStartChange,
        onOpenChange: this.handleStartOpenChange
      })), getFieldDecorator("onendchange", {
        rules: [{ required: false, message: "" }]
        // initialValue: this.state.endValue
      })((0, _jsx3.default)(_datePicker2.default, {
        disabledDate: this.disabledEndDate,
        showTime: true,
        allowClear: true,
        style: { width: 190 },
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '\u7ED3\u675F\u65F6\u95F4',
        onChange: this.onEndChange,
        open: endOpen,
        onOpenChange: this.handleEndOpenChange
      }))), (0, _jsx3.default)('div', {
        className: 'battery-allstatus'
      }, void 0, getFieldDecorator("handlechange", {
        rules: [{ required: false, message: "" }]
        // initialValue: onlineStatus
      })((0, _jsx3.default)(_select2.default, {
        showSearch: true,
        size: 'large',
        allowClear: true,
        placeholder: '\u5F53\u524D\u72B6\u6001',
        style: { width: 100, marginRight: 20 },
        onChange: this.handleChange.bind(this)
      }, void 0, chargingStatus.map(function (item, index) {
        return (0, _jsx3.default)(Option, {
          value: item.key
        }, index, item.name);
      }))), getFieldDecorator("handlechangeone", {
        rules: [{ required: false, message: "" }]
        // initialValue: statusValue
      })((0, _jsx3.default)(_select2.default, {
        showSearch: true,
        size: 'large',
        allowClear: true,
        placeholder: '\u6709\u7EBF/\u65E0\u7EBF',
        style: { width: 120, marginRight: 20 },
        onChange: this.handleChangeOne.bind(this)
      }, void 0, _ref3, _ref4, _ref5))), (0, _jsx3.default)('div', {
        className: 'sousuo',
        style: { width: 150, marginRight: 20 }
      }, void 0, getFieldDecorator("searchnumbervalue", {
        rules: [{ required: false, message: "" }]
        // initialValue: this.state.searchNumberValue
      })((0, _jsx3.default)(_input2.default, {
        placeholder: '\u786C\u4EF6SN\u53F7/\u7535\u6C60\u89C4\u683C',
        style: { width: 150 },
        onChange: this.searchNumber.bind(this)
      }))), (0, _jsx3.default)('div', {
        className: 'battery-number',
        style: { width: 150, marginRight: 25 }
      }, void 0, (0, _jsx3.default)('div', {
        className: 'battery-number-one'
      }, void 0, (0, _jsx3.default)(_slider2.default, {
        marks: marks,
        range: true,
        onChange: this.onSohChange.bind(this),
        step: 10,
        defaultValue: this.state.sohArr,
        style: { width: 150, marginRight: 10, display: 'inline-block' }
      }))), (0, _jsx3.default)(_button2.default, {
        type: 'primary',
        icon: 'search',
        style: {},
        onClick: this.handleGetList.bind(this)
      }, void 0, '\u641C\u7D22')), (0, _jsx3.default)('div', {
        className: 'battery-table'
      }, void 0, (0, _jsx3.default)(_table2.default, {
        className: 'list',
        columns: columns,
        dataSource: this.state.data,
        pagination: this.state.p,
        onChange: this.handlePage.bind(this)
      })), (0, _jsx3.default)(_modal2.default, {
        title: '\u5220\u9664',
        visible: this.state.visible,
        onOk: this.handleDel.bind(this),
        onCancel: this.cancelDeleteModal.bind(this)
      }, void 0, _ref6));
    }
  }]);
  return BatMan;
}(_react.Component);

exports.default = _form2.default.create()(BatMan);

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/batteryManagement/index.jsx
// module id = 1565
// module chunks = 0